<template>
  <span :title="val" :class="{ 'true': val, 'false': !val, }">
    {{val ? '✓' : '✕'}}
  </span>
</template>

<script>
export default {
  props: {
    val: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
  .true {
    color: $green-color1 !important;
  }
  .false {
    color: $red-color3 !important;
  }
</style>





// WEBPACK FOOTER //
// src/components/pages/admin/BooleanEl.vue